import angular from 'angular';
import { dynamicSort } from '@/shared/utils/dynamicSort';

angular.module('cloudX').directive('cxUserInputXedit', [
  '$filter',
  'dataCache',
  function($filter, dataCache) {
    return {
      restrict: 'E',
      template: `<div>
          <div ng-if="readonly">
            <span ng-repeat="u in displayValue track by $index" ng-class="{'removed-user': u.isInactive}">{{u.name}}<span ng-if="!$last">, </span></span>
          </div>
          <form data-editable-form name="tagsForm" class="tagsForm" onbeforesave="beforeSave($data.tags, tagsForm)" ng-if="!readonly">
            <div editable-tags-input="innerValue" data-e-form="tagsForm" data-e-name="tags" name="tags" e-replace-spaces-with-dashes="false" e-placeholder="{{('Add a user'|translate)}}" e-add-from-autocomplete-only="true" e-min-length="1">
              <a href="" ng-click="readValue(); tagsForm.$show();" ng-show="!tagsForm.$visible" title="{{('Edit users'|translate)}}">
                <span ng-show="displayValue.length">
                  <span ng-repeat="u in displayValue track by $index">
                    <span ng-class="{'removed-user': u.isInactive}">{{u.name}}</span><span ng-if="!$last">, </span>
                  </span>
                </span>
                <i class="glyphicon glyphicon-pencil" ng-hide="displayValue.length"></i>
              </a>
              <editable-tags-input-auto-complete min-length="1" source="loadTags($query)" load-on-down-arrow="true"></editable-tags-input-auto-complete>
            </div>
            <div class="buttons">
              <span ng-show="tagsForm.$visible">
                <button type="submit" class="btn btn-inverse btn-xs" ng-disabled="tagsForm.$waiting" data-translate>Save</button>&nbsp;
                <button type="button" class="btn btn-default btn-xs" ng-disabled="tagsForm.$waiting" ng-click="tagsForm.$cancel()" data-translate>Cancel</button>
              </span>
            </div>
          </form>
        </div>`,
      scope: {
        value: '=data',
        save: '&',
        readonly: '=?',
      },
      link: function(scope) {
        scope.innerValue = [];
        scope.options = null;
        scope.displayValue = [];

        const buildOptions = () =>
          dataCache
            .getArray('user')
            .filter(x => x.isActive || !x.hidden)
            .map(u => {
              const name = `${u.firstName} ${u.lastName}`;
              return {
                id: u.userID,
                name,
                text: (u.isActive ? '' : '⚠ ') + name,
              };
            })
            .sort(dynamicSort('name'));

        const findUser = userId => {
          const userObject = dataCache.getObject('user');
          const user = userObject ? userObject[userId] : null;
          if (!user) return null;
          const name = `${user.firstName} ${user.lastName}`;
          return {
            id: user.userID,
            name,
            text: (user.isActive ? '' : '⚠ ') + name,
          };
        };

        scope.loadTags = function(search) {
          if (scope.options !== null) return $filter('filter')(scope.options, search);
          return dataCache.ready().then(function() {
            scope.options = buildOptions();
            return $filter('filter')(scope.options, search);
          });
        };

        scope.setDisplayValue = function(value) {
          if (typeof value === 'string') value = JSON.parse(value);
          const userObject = dataCache.getObject('user');
          scope.displayValue = (value || [])
            .map(id => {
              const user = userObject ? userObject[id] : null;
              if (!user) return null;
              return {
                name: `${user.firstName} ${user.lastName}`,
                isInactive: !user.isActive,
              };
            })
            .filter(Boolean);
        };

        scope.readValue = function() {
          let value = scope.value;
          if (typeof value === 'string') value = JSON.parse(value);
          if (angular.isArray(value)) {
            scope.innerValue = value.map(findUser).filter(Boolean);
          } else {
            scope.innerValue = [];
          }
        };

        scope.$watch(
          'value',
          function(newValue) {
            dataCache.ready().then(function() {
              scope.readValue();
              scope.setDisplayValue(newValue);
            });
          },
          true,
        );

        scope.beforeSave = function(data) {
          const ids = data.map(x => x.id);
          return scope.save({ $data: ids }).then(
            () => {
              scope.value = ids;
              scope.setDisplayValue(ids);
              return false;
            },
            () => '',
          );
        };
      },
    };
  },
]);
